import persado_logo_white from "../assets/persado_logo_white.png";
import persado_logo_black from "../assets/persado-logo-black.png";
import pieces_black from "../assets/pieces_black.png";
import pieces_white from "../assets/pieces_white.png";
import GA_Logo2 from "../assets/GA_Logo2.png";
import carhartt_wip_text_logo_white from "../assets/carhartt_wip_text_logo-white.png";
import carhartt_wip_text_logo_black from "../assets/carhartt_wip_text_logo.png";
import Unis from "../assets/Unis.png";
import adobephotoshop from "../assets/Skills/adobephotoshop.png";
import asana from "../assets/Skills/asana.png";
import bootstrap from "../assets/Skills/bootstrap.png";
import css3 from "../assets/Skills/css3-alt.png";
import django from "../assets/Skills/django.png";
import html5 from "../assets/Skills/html5.png";
import git from "../assets/Skills/icons8-git.png";
import excel from "../assets/Skills/icons8-microsoft-excel.png";
import mongodb from "../assets/Skills/icons8-mongodb.png";
import python from "../assets/Skills/icons8-python.png";
import reactnative from "../assets/Skills/icons8-react-native.png";
import visualstudio from "../assets/Skills/icons8-visual-studio-code-2019.png";
import js from "../assets/Skills/js.png";
import mailchimp from "../assets/Skills/mailchimp copy 2.png";
import node from "../assets/Skills/node-js.png";
import postgresql from "../assets/Skills/postgresql.png";
import react from "../assets/Skills/react.png";
import semanticuireact from "../assets/Skills/semanticuireact.png";
import shopify from "../assets/Skills/shopify.png";
import sketch from "../assets/Skills/sketch.png";
import liquid from "../assets/Skills/liquid.png"



export const Jobs = [
  {
    company: "Persado",
    title: "Front End Developer",
    timeline: "10 / 2021 - Present",
    image: `${persado_logo_white}`,
    image_2: `${persado_logo_black}`,
    description:
      "Assigned to Persado's most demanding and valuable account within the retail vertical. Built and delivered multi-variant marketing campaign assets and/or web experiences using a variety of design tools and technologies. Identified oportunities to streamline and automate internal processes to improve efficiency within tight SLAs and timelines.",
    skills: "HTML, CSS, JavaSript, Python, Excel, Photoshop, Sketch, Adobe XD",
    link: "https://www.persado.com/"
  },
  {
    company: "Pieces Home",
    title: "Freelance Developer / Ecom Assoc.",
    timeline: "10 / 2021 - Present",
    image: `${pieces_white}`,
    image_2: `${pieces_black}`,
    description:
      "Migrated theme for compatability with Online Store 2.0. Established development workflow using Shopify CLI + Git + GitHub. Develop new and existing theme templates for desired business needs. Integrate storefront with third-party Apps and APIs. Write intenal documentation outlining theme customizations + standard operating procedures.",
    skills: "Liquid, Shopify, Git, Klavyio, HTML, CSS, Javascript",
    link: "https://pieceshome.com/"
  },
  {
    company: "General Assembly",
    title: "Software Engineering Immersive",
    timeline: "5 / 2021 - 8 / 2021",
    image: `${GA_Logo2}`,
    image_2: `${GA_Logo2}`,
    description:
      "Engaged in a 12 week, 500+ hour, remote software engineering immersive course while learning programming and computer science fundamentals in regards to full-stack development. Worked collaboratively in an agile development workflow using industry-standard version control tools. ",
    skills: "HTML, CSS, JavaSript, MERN, Git",
    link: "https://generalassemb.ly/education/software-engineering-immersive/new-york-city"
  },
  {
    company: "Carhartt WIP",
    title: "Content Manager",
    timeline: "3 / 2018 - 5 / 2021",
    image: `${carhartt_wip_text_logo_white}`,
    image_2: `${carhartt_wip_text_logo_black}`,
    description:
      "Managed product data for 1000+ SKUs per season. Executed weekly site-wide content updates to align with sales-performance and marketing initiatives. Arranged and built biweekly newsletter campaigns utilizing Sketch and Mailchimp ESP. Coordinated feature deployments with external dev team.",
    skills: "Shopify, Mailchimp, Excel, Sketch, Photoshop, Amplience CMS",
    link: "https://us.carhartt-wip.com/"
  },
  {
    company: "Unis New York",
    title: "Ecommerce Manager",
    timeline: "6 / 2015 - 12 / 2017",
    image: `${Unis}`,
    image_2: `${Unis}`,
    description:
      "Owned all Ecommerce business operations including, but not limited to: order fulfillment, customer service, merchandising, SEO, and photo production.",
    skills: "Shopify, Lightspeed, Mailchimp, Excel, Photoshop",
    link: "https://www.unisnewyork.com/"
  },
];

export const Skills = [
  {
    title: "Git",
    logo: git ,
  },
  {
    title: "HTML-5",
    logo: html5,
  },
  {
    title: "CSS",
    logo: css3,
  },
  {
    title: "Javascript",
    logo: js,
  },
  {
    title: "Node.js",
    logo: node,
  },
  {
    title: "React",
    logo: react,
  },
  {
    title: "React Native",
    logo: reactnative,
  },
  {
    title: "Shopify",
    logo: shopify,
  },
  {
    title: "Liquid",
    logo: liquid,
  },
  {
    title: "Bootstrap",
    logo: bootstrap ,
  },
  {
    title: "Semantic UI",
    logo: semanticuireact,
  },
  {
    title: "VS Code",
    logo: visualstudio,
  },
  {
    title: "Python",
    logo: python,
  },
  {
    title: "Django",
    logo: django,
  },
  {
    title: "MongoDB",
    logo: mongodb,
  },
  {
    title: "PostgreSQL",
    logo: postgresql,
  },
  {
    title: "Mailchimp",
    logo: mailchimp,
  },
  {
    title: "Microsoft Excel",
    logo: excel,
  },
  {
    title: "Asana",
    logo: asana,
  },
  {
    title: "Sketch",
    logo: sketch,
  },
  {
    title: "Adobe Photoshop",
    logo: adobephotoshop,
  }
];
